module.exports = __webpack_public_path__ + "media/images/application/icons/instagram-logo-e7ca95799eba827c73a901d897fb3823.svg";